<template>
  <sc-page :title="schema.title" :desc="schema.desc" ref="table">
    <div class="body">
      <widget-search
        :form="form"
        :groups="groups"
        @search="onSearch"
        :show="showSearch"
      />
      <widget-table-button :buttons="buttons">
        <widget-search-btn v-model="showSearch" />
      </widget-table-button>
      <widget-table-body
          @change="onChange"
          :list-data="listData"
          :columns="columns"
          :row-selection="rowSelection"
          :select-row-key="schema.primary"
      />
      <!--    分页    -->
      <widget-table-pagination :count="listData.count" v-model:page-num="tableService.listConfig.pageNum"
                               v-model:page-size="tableService.listConfig.pageSize"/>
      <a-back-top :target="backTopTarget" :visibilityHeight="100"/>
    </div>
  </sc-page>
</template>
<script setup lang="ts">
import {ComponentPublicInstance, ref, watch} from 'vue';
import {createCrudTableService} from './service/CrudTableService';
import WidgetTablePagination from "@/components/business/crud/table/WidgetTablePagination.vue";
import WidgetTableButton from "@/components/business/crud/table/WidgetTableButton.vue";
import WidgetTableBody from "@/components/business/crud/table/WidgetTableBody.vue";
import {bindRef, useQueryParam} from "@/util/queryParam";
import WidgetSearch from "@/components/business/crud/form/WidgetSearch.vue";
import {createSearchService} from "@/components/business/crud/service/CrudSearchService";
import _ from "lodash";
import WidgetSearchBtn from '@/components/business/crud/form/WidgetSearchBtn.vue';

const props = defineProps<{
  moduleName: string;
  controllerName: string;
}>();
const showSearch = ref(false)
const searchService = createSearchService(props.moduleName, props.controllerName);
const {form, groups, getCondition} = searchService.use();
const tableService = createCrudTableService(props.moduleName, props.controllerName);
const {
  schema,
  columns,
  listData,
  rowSelection,
  onChange,
  buttons,
} = tableService.use();

const searchData = useQueryParam("searchData");
const readonlyFields = useQueryParam("readonlyFields");

/**
 * 查询时候修改列表查询条件，将查询数据同步到url上
 */
function onSearch() {
  tableService.listConfig.condition = getCondition();
  searchData.value = _.cloneDeep(form.data.value);
}

let isInit = false;

const queryParam = useQueryParam("table");
searchService
    .init()
    .then(() => {
      /**
       * 监听url数据，来修改查询表单数据
       */
      watch(searchData, () => {
        const queryValue = searchData.value || {};
        if (!_.isEqual(queryValue, form.data.value)) {
          form.data.value = queryValue;
        }
      }, {deep: true, immediate: true});
      /**
       * 监听url数据，来设置查询表单只读字段
       * todo 双向绑定
       */
      watch(() => readonlyFields, () => {
        if (readonlyFields.value) {
          searchService.setReadonlyFields(readonlyFields.value);
          if (isInit) {
            onSearch();
          }
        }
      }, {deep: true, immediate: true})
      /**
       * 监听url数据，来修改列表排序字段
       * todo 双向绑定
       */
      watch(() => queryParam.value?.orderBy, () => {
        onChange(undefined, undefined, queryParam.value?.orderBy || []);
      }, {deep: true, immediate: true})
      if (!isInit) {
        isInit = true;
        onSearch();
      }
      tableService.init()
    });


const table = ref<ComponentPublicInstance>();

function backTopTarget() {
  return table.value?.$el;
}

</script>

<style lang="scss" scoped>
.body {
  padding: $spacing-medium;
}

.ant-back-top {
  bottom: 100px;
  right: 100px;
}
</style>
